import React from "react";
import ServiceTemplate from "./ServiceTemplate";
import { Settings } from "lucide-react";

const serviceData = {
  id: "gtc",
  title: "GTC et GTB",
  description: "Gestion technique et énergétique des bâtiments",
  icon: Settings,
  image: "/GTC.jpg", // Updated path
  longDescription: [
    "Nos solutions de Gestion Technique Centralisée (GTC) et Gestion Technique du Bâtiment (GTB) permettent une supervision complète et une optimisation de vos installations techniques.",
    "Nous intégrons des systèmes intelligents qui vous permettent de contrôler et d'optimiser la consommation énergétique, le confort et la sécurité de vos bâtiments.",
  ],
  features: [
    "Supervision centralisée des équipements",
    "Contrôle des systèmes CVC",
    "Gestion de l'éclairage",
    "Monitoring énergétique",
    "Automatisation des process",
    "Interface utilisateur intuitive",
  ],
  benefits: [
    "Réduction des coûts énergétiques",
    "Optimisation du confort des occupants",
    "Maintenance prédictive",
    "Contrôle à distance",
    "Rapports et analyses détaillés",
  ],
};

const GtcGtb = () => {
  return <ServiceTemplate service={serviceData} />;
};

export default GtcGtb;
